import gql from 'graphql-tag';

import ConnectedEmailFields from './subfragments/ConnectedEmailFields';

export default gql`
  fragment AccountMailboxFields on AccountMailbox {
    __typename
    email {
      ...ConnectedEmailFields
    }
  }

  ${ConnectedEmailFields}
`;
